import { Component, Input, ViewChild } from '@angular/core';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ApiService } from '../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { DocumentoAccredito, Evento, Persona, Subappalto } from '../../shared/interface';

@Component({
  selector: 'app-file-loaded',
  templateUrl: './file-loaded.component.html',
  styleUrl: './file-loaded.component.css'
})
export class FileLoadedComponent {

  constructor (private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild(ConfirmPopup) delete!: ConfirmPopup;

  @Input() evento?: Evento;
  @Input() persona?: Persona;
  @Input() subappalto?: Subappalto;
  @Input() documento?: DocumentoAccredito;

  @Input() tipo: string = '';
  @Input() file: string = '';
  @Input() label = '';
  @Input() tooltip = '';
  @Input() title = '';
  @Input() meta = '';
  @Input() status = '';
  @Input() critical = false;

  get fileName(): string {
    const raw = (this.file || '').toString().split(/[\\/]/).pop() || '';
    return raw || 'Documento caricato';
  }

  get ext(): string {
    const name = this.fileName;
    const i = name.lastIndexOf('.');
    if (i < 0) return 'FILE';
    const e = name.slice(i + 1).toUpperCase();
    return e.length <= 4 ? e : 'FILE';
  }

  onDocumento(documento: string) {
    this.apiService.openProtectedFile(documento);
  }

  onOpenDelete(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il documento caricato?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        if (this.documento)
          this.deleteDocumento();
        else if (this.subappalto)
          this.deleteDocumentoSubappalto();
        else
          this.deleteDocumentoCompagnia();
      },
    });
  }

  onDelete() {
    this.delete.accept()    
  }

  onCloseDelete() {
    this.delete.reject();    
  }

  deleteDocumentoCompagnia() {
    this.apiService.deleteDocumentoCompagnia(this.evento!.id, this.tipo).subscribe({
      next: (data) => {
        if (this.tipo === 'merchandising_visura' && this.evento) this.evento.merchandising_visura = '';
        this.apiService.setDocumentiEvento(this.evento!.id);
      },
      error: (err) => this.apiService.message('error', 'Errore', this.errMsg(err)),
      complete: () => {
        this.confirmationService.close();
        this.apiService.message('success', 'Eliminazione', 'Il documento è stato rimosso con successo!');
      },
    });
  }

  private errMsg(err: any, fallback = 'Operazione non riuscita'): string {
    const m = err?.error?.message;
    if (typeof m === 'string' && m.trim()) return m;
    if (m?.message) return String(m.message);
    return fallback;
  }

  deleteDocumentoSubappalto() {
    this.apiService.deleteDocumentoSubappalto(this.subappalto!.id, this.tipo).subscribe({
      next: () => {
        this.file = '';
        if (this.subappalto && this.tipo) (this.subappalto as any)[this.tipo] = '';
        if (this.subappalto?.id_evento) {
          this.apiService.setSubappaltiEvento(this.subappalto.id_evento);
          this.apiService.setDocumentiEvento(this.subappalto.id_evento);
        }
      },
      error: (err) => this.apiService.message('error', 'Errore', this.errMsg(err)),
      complete: () => {
        this.confirmationService.close();
        this.apiService.message('success', 'Eliminazione', 'Il documento è stato rimosso con successo!');
      },
    });
  }

  deleteDocumento() {
    this.apiService.deleteDocumentoAccredito(this.documento!.id).subscribe({
      next: (data) => this.apiService.setDocumentiEvento(this.evento!.id),
      error: (err) => this.apiService.message('error', 'Errore', this.errMsg(err)),
      complete: () => {
        this.confirmationService.close();
        this.apiService.message('success', 'Eliminazione', 'Il documento è stato eliminato con successo!');
      },
    });
  }

}
